import LocalizedStrings from "react-localization";

let footerStrings = new LocalizedStrings({
    en: {
        privacy: "Privacy Policy",
        pressKit: "Press Kit",
        tos: "Terms of Service",
        cookie: "Cookie Policy",
    },
});

export default footerStrings;